import { useMutation } from "@tanstack/react-query";
import { Api, type UpdateUserRoleRequest } from "@/api";
import { usersKeys } from "./keys";

type UpdateUserRoleInput = UpdateUserRoleRequest & { id: string };

/** Меняет роль пользователя из админки. */
export const useUpdateUserRole = () => {
	const mutation = useMutation({
		mutationFn: ({ id, role }: UpdateUserRoleInput) =>
			Api.User.putApiUsersRoleById({ id }, { role }),
		mutationKey: usersKeys.updateRole,
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
